var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

jQuery(document).ready(function($){
  var numofP = $('.announcement-bar p').length;
  if( numofP > 1 ) {
    $('.announcement-bar').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      dots: false
    });
  }
});